import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { WalletProvider } from "@/contexts/WalletContext";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { ThemeProvider, useTheme } from "@/contexts/ThemeContext";
import Landing from "@/pages/Landing";
import DashboardLayout from "@/components/layout/DashboardLayout";
import Dashboard from "@/pages/Dashboard";
import WalletPage from "@/pages/Wallet";
import Staking from "@/pages/Staking";
import Team from "@/pages/Team";
import Achievements from "@/pages/Achievements";
import Support from "@/pages/Support";
import Admin from "@/pages/Admin";
import AdminLogin from "@/pages/AdminLogin";
import { TelegramFAB } from "@/components/TelegramFAB";

function ProtectedRoute({ children }) {
  const { token, hydrated } = useAuth();
  if (!hydrated) return null;
  if (!token) return <Navigate to="/" replace />;
  return children;
}

function AppShell() {
  const { theme } = useTheme();
  return (
    <div className={`App ${theme} relative`}>
      <div className="app-bg-orbs"><i /></div>
      <WalletProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Landing />} />
              {/* Admin panel — separate auth via /control username+password (no wallet needed) */}
              <Route path="/control" element={<AdminLogin />} />
              <Route path="/admin" element={<Admin />} />
              <Route element={<ProtectedRoute><DashboardLayout /></ProtectedRoute>}>
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/wallet" element={<WalletPage />} />
                <Route path="/staking" element={<Staking />} />
                <Route path="/team" element={<Team />} />
                <Route path="/achievements" element={<Achievements />} />
                <Route path="/rank" element={<Navigate to="/achievements" replace />} />
                <Route path="/support" element={<Support />} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
          <Toaster theme={theme === "light" ? "light" : "dark"} position="top-right" richColors />
          {/* Floating Telegram button — appears on every page, opens official channel */}
          <TelegramFAB />
        </AuthProvider>
      </WalletProvider>
    </div>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AppShell />
    </ThemeProvider>
  );
}

export default App;
